(() => {
  const initializeComparison = (root) => {
    if (!root || root.dataset.comparisonInitialized === 'true') return;
    root.dataset.comparisonInitialized = 'true';

    root.querySelectorAll('[data-best-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-best-tab]').forEach((tab) => {
          const isActive = tab === button;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });

        root.querySelectorAll('[data-best-pane]').forEach((pane) => {
          pane.classList.toggle('is-active', pane.dataset.bestPane === button.dataset.bestTab);
        });
      });
    });

    root.querySelectorAll('[data-comparison-faq]').forEach((faqSection) => {
      const items = [...faqSection.querySelectorAll('.faq-item')];

      const setOpen = (item, open) => {
        const button = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer-wrapper');
        const chevron = item.querySelector('.chevron');
        if (!button || !answer) return;

        button.setAttribute('aria-expanded', String(open));
        answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '';
        if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : 'rotate(0deg)';
      };

      items.forEach((item, index) => {
        setOpen(item, index === 0);
        item.querySelector('.faq-question')?.addEventListener('click', () => {
          const shouldOpen = item.querySelector('.faq-question')?.getAttribute('aria-expanded') !== 'true';
          items.forEach((otherItem) => setOpen(otherItem, shouldOpen && otherItem === item));
        });
      });
    });
  };

  const initializeAll = (container = document) => {
    container.querySelectorAll('[data-comparison-cms]').forEach(initializeComparison);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
